import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { useNavigate, useParams } from "react-router-dom";
import { Team, User } from "types";

export const TeamContext = ({ children, team, user }: { children: React.ReactNode, team: Team, user: User }) => {
    const {teamId} = useParams();
    const navigate = useNavigate();
    const handleLeaveTeam = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: team.id }),
        });
        const data = await response.json();
        if (data.message) return;
        if (team.id === teamId) navigate(`/`);
    }

    return (
        <ContextMenu>
            <ContextMenuTrigger>
                {children}
            </ContextMenuTrigger>
            <ContextMenuContent className="bg-brand-default min-w-60 p-0 px-0 py-0 space-y-0 font-bold rounded-lg text-white border-0 shadow-xl shadow-brand ">
                {team.createdBy !== user.id && (
                    <ContextMenuItem className="hover:bg-brand-profile bg-brand-profile/75 transition-all duration-200 cursor-pointer text-red-400 focus:text-red-400 focus:bg-brand-profile" onClick={handleLeaveTeam}>
                        Leave Team
                    </ContextMenuItem>
                )}
            </ContextMenuContent>
        </ContextMenu>
    );
};
